"use client";
import Image from "next/image";

import { cva } from "../../styled-system/css";

const blogArticleRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "500px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backgroundColor: "white",
  },
});

const blogImageRecipe = cva({
  base: {
    objectFit: "contain",
    objectPosition: "center",
    width: "100%",
    alignSelf: "stretch",
    minWidth: "20px",
    minHeight: "20px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
});

const blogSummaryRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: "30px",
  },
});

const blogTitleRecipe = cva({
  base: {
    color: "black",
    textAlign: "left",
    width: "100%",
    flexGrow: "1",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    font: '24px/30px "Inter", sans-serif ',
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    lineClamp: 3,
  },
});

const blogTextRecipe = cva({
  base: {
    color: "black",
    textAlign: "left",
    marginTop: "13px",
    font: '15px/22p "Inter", sans-serif ',
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    lineClamp: 4,
  },
});

const metaDataRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "row",
    maxWidth: "319px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginTop: "13px",
  },
});

const timeStampRecipe = cva({
  base: {
    maxWidth: "78px",
    opacity: "0.85",
    color: "black",
    letterSpacing: "0%",
    textAlign: "left",
    margin: "auto 0",
    font: '13px/24px "Inter", sans-serif ',
  },
});

const readEstimateRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "row",
    maxWidth: "79px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    opacity: "0.85",
    margin: "auto 0 auto 24px",
    letterSpacing: "0%",
    color: "black",
    font: '13px/24px "Inter", sans-serif ',
  },
});

const authorWrapperRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "row",
    maxWidth: "319px",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "8px",
  },
});

const authorPictureRecipe = cva({
  base: {
    aspectRatio: "1",
    objectFit: "cover",
    objectPosition: "center",
    width: "45px",
    minWidth: "20px",
    minHeight: "20px",
    maxWidth: "45px",
    justifyContent: "flex-start",
    alignItems: "center",
  },
});

const authorNameRecipe = cva({
  base: {
    maxWidth: "39px",
    marginLeft: "12px",
    color: "black",
    letterSpacing: "0%",
    textAlign: "left",
    width: "auto",
    flexGrow: "1",
    font: '14px/24px "Inter", sans-serif ',
  },
});

function BlogCardComponent() {
  return (
    <article className={blogArticleRecipe()}>
      <Image
        unoptimized
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41?width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbff0496639f54b9cb2f4d53e2bf3ab41"
        width={0}
        height={0}
        className={blogImageRecipe()}
        alt="TO DO: ADD VARIABLE FOR ALT VALUE HERE"
      />
      <div className={blogSummaryRecipe()}>
        <h1 className={blogTitleRecipe()}>
          New Martine Rose x Nike Shox MR4 Colors Coming Spring 2024 121
          2312331231 12
        </h1>
        <p className={blogTextRecipe()}>
          Martine Rose, a London-based fashion designer, is collaborating with
          Nike to launch a vibrant range of Nike Shox MR4s. During Martine
          Rose’s Spring/Summer 2024 London…
        </p>
        <div className={metaDataRecipe()}>
          <time className={timeStampRecipe()} dateTime="2022-10-10">
            3 days ago
          </time>
          <div className={readEstimateRecipe()}>2 min read</div>
        </div>
        <div className={authorWrapperRecipe()}>
          <Image
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=100 100w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=200 200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=400 400w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=800 800w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=1200 1200w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=1600 1600w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a?width=2000 2000w, https://cdn.builder.io/api/v1/image/assets%2FTEMP%2Fbc06236f2992420aac2b8a03222ff93a"
            width={0}
            height={0}
            className={authorPictureRecipe()}
            alt="TO DO: ADD VARIABLE FOR ALT VALUE HERE"
          />
          <div className={authorNameRecipe()}>Joe H</div>
        </div>
      </div>
    </article>
  );
}

export default BlogCardComponent;
